import { ISystemProductionStage } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetProductionStagesQuery<D extends ISystemProductionStage[]>(
  params?: HydraQueryParams<D>
) {
  const { vars, options } = params || {};
  return useHydraQuery<D>('productionStages', '/api/production_stages', {
    vars,
    options,
  });
}
